// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sale-report-index[data-v-67d5df0e]  ul.nav.nav-pills{margin-bottom:.5rem}", ""]);
// Exports
module.exports = exports;
